import { Outlet} from "react-router-dom";
import { Aside } from "../../components/Dashboard/Aside";
import { useState } from "react";

export const Dashboard = () => {
    const [isOpen, setIsOpen] = useState(true);

    const handleAsideClick = () => {
        setIsOpen(!isOpen)
    }

    return (
        <main className="bg-[white] flex gap-3 min-h-dvh">
            <Aside isOpen={isOpen} handleAsideClick={handleAsideClick}/>
            <Outlet />
        </main>
    )
}